import _ from 'lodash';

const invDashboardAnalysisConfig = {
	initialState: {
		fields: {
			amountCaption: [
				{
					caption: 'Production Cost',
					amount: 'N/A',
				},
				{
					caption: 'Inv Consumed',
					amount: 'N/A',
				},
				{
					caption: 'Production Loss',
					amount: 'N/A',
				},
				{
					caption: 'Production Loss %',
					amount: 'N/A',
				},
				{
					caption: 'Wastage',
					amount: 'N/A',
				},
				{
					caption: 'Wastage %',
					amount: 'N/A',
				},
			],
		},
	},
	serializer: (state, data) => {
		return _.update(_.cloneDeep(state), 'fields', () => {
			const newState = {
				amountCaption: [
					...Object.keys(data).map((current) => {
						let percentage = null;
						if ('percentageValue' in data?.[current]) {
							percentage = data?.[current]?.percentageValue;
						}
						return {
							caption: data[current].label,
							amount: data[current]?.value,
							color: data?.[current]?.color,
							percentageValue: percentage
								? `${percentage} %`
								: null,
						};
					}),
				],
			};
			return newState;
		});
	},
};
export default invDashboardAnalysisConfig;
